<template>
  <AppModal
    v-model="showModal"
    action-close
    centered
    class="app-confirmation-modal"
    :hide-footer="false"
    :title="title"
    @decline="$emit('decline')"
    @hide="$emit('hide')"
    @hidden="$emit('hidden')"
    @save="$emit('save')"
    @show="$emit('show')"
    @shown="$emit('hidden')"
  >
    <template #default>
      <slot name="default">
        <span class="body">Are you sure?</span>
      </slot>
    </template>
    <template #footer-action-cancel>No</template>
    <template #footer-action-submit>Yes</template>
  </AppModal>
</template>

<script>
import AppModal from '@/components/modals/AppModal.vue';

export default {
  components: { AppModal },
  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: this.value,
    };
  },
  watch: {
    showModal(value) {
      this.$emit('input', value);
    },
    value(val) {
      this.showModal = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-confirmation-modal {
  .body {
    font-size: 18px;
  }

  &.app-modal-wrapper {
    ::v-deep {
      .app-modal-body {
        padding-top: 0;
        padding-bottom: 90px;
      }
    }
  }
}
</style>
